import { logNewRelicPageAction } from '@makemydeal/dr-activities-common';
import { BALLOON, CASH, FINANCE, LEASE, TaxNames } from '@makemydeal/dr-platform-types';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';

// interfaces/types
import type { StateTree } from '@makemydeal/dr-dash-types';

// selectors
import * as offerReduxSelectors from '../selectors/offerRedux';

// utils
import { buildUsabilityContext } from './usabilityContext';

export const TAX_RATE_ON_OPEN_EVENT = 'MV:TaxRateOnOpen';

const OFFER_TYPES = [FINANCE, LEASE, CASH, BALLOON] as const;
const MISMATCH_RATIO_THRESHOLD = 10;

export const logTaxRatesOnOpen = (state: StateTree): void => {
    try {
        const counts = { typedRateCount: 0, checkedCount: 0, decimalCount: 0, tooHighCount: 0 };
        const problemTaxNames = new Set<string>();

        OFFER_TYPES.forEach((offerType) => {
            offerReduxSelectors.getTaxItemsWithOverridesWithoutFlat(state, offerType).forEach((item) => {
                if (!item.manualChanges?.taxRate) {
                    return;
                }
                counts.typedRateCount++;

                const rate = Number(item.taxRate);
                const amount = Number(item.taxAmount) || 0;
                const basis = Number(item.taxBasisAmount) || 0;
                const isAmountOverride = Boolean(item.isManualTaxAmount || item.manualChanges.taxAmount);
                if (!rate || item.taxName === TaxNames.MonthlyUseTax || amount <= 0 || basis <= 0 || isAmountOverride) {
                    return;
                }
                counts.checkedCount++;

                const ratio = rate / ((amount / basis) * 100);
                if (ratio < 1 / MISMATCH_RATIO_THRESHOLD) {
                    counts.decimalCount++;
                    problemTaxNames.add(`${offerType}:${item.taxName}`);
                } else if (ratio > MISMATCH_RATIO_THRESHOLD) {
                    counts.tooHighCount++;
                    problemTaxNames.add(`${offerType}:${item.taxName}`);
                }
            });
        });

        if (!counts.typedRateCount) {
            return;
        }

        logNewRelicPageAction(TAX_RATE_ON_OPEN_EVENT, {
            ...counts,
            uncheckedCount: counts.typedRateCount - counts.checkedCount,
            problemTaxNames: [...problemTaxNames].join(','),
            percentTaxRatesToggle: featureToggleSelectors.isPercentTaxRatesEnabled(state),
            ...buildUsabilityContext(state)
        });
    } catch (error) {
        logNewRelicPageAction(TAX_RATE_ON_OPEN_EVENT, { failed: true, errorMessage: String(error) });
    }
};
